/* eslint-disable react-refresh/only-export-components */
import { useCallback, useEffect } from 'react';

import { useAuth } from '@contexts/auth';

import RedirectManager from './RedirectManager';

export function callRedirect(): void {
  const ref = RedirectManager.getDefault();

  if (ref) {
    ref.redirect();
  }
}

const Redirect = () => {
  const { onLogout } = useAuth();
  const redirect = useCallback(() => {
    onLogout();
  }, [onLogout]);

  useEffect(() => {
    RedirectManager.register({ redirect });
  }, [redirect]);

  return null;
};

export default Redirect;
